// @ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  Button,
  Panel,
  IconButton,
  Stack,
  Divider,
  Table,
  Input,
  Col,
  Whisper,
  Modal,
  Tooltip,
  SelectPicker,
  Grid,
  Row,
  useToaster,
  Message,
  Loader,
  InputNumber
} from 'rsuite';
import { useLocation, useNavigate } from 'react-router-dom';
import globalIP from '@/GlobelIP';
import TrashIcon from '@rsuite/icons/Trash';
import { Icon } from '@rsuite/icons';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import axios from 'axios';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import { handleDecrypt } from '@/functions';
import useLabel from './hook/Label';
import ugr from '@/UGRoute';
const { Column, HeaderCell, Cell } = Table;

type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    SellingPrice: number;
    MOQ: number;
  };
};
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const BuyerWeb = () => {
  const [enquiry, setEnquiry] = useState({
    TypeCode: '',
    Type: '',
    buyername: '',
    buyercode: '',
    enqcd: '',
    Comment: '',
    query: '',
    EnquiryProduct: [
      {
        Prdcd: '',
        remark: '',
        enqcd: '',
        BuyerPrice: '',
        productid: '',
        query: ''
      }
    ]
  });
  const toaster = useToaster();
  const navigate = useNavigate();
  const [showTabs, setShowTabs] = useState(2);
  const [queryAllData, setQueryAllData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [message, setMessage] = useState('');
  const selectData = ['Show Pricing', 'Need Sample', 'Order Confirm'].map(item => ({
    label: item,
    value: item
  }));
  const { attributesName } = useLabel();
  const defaultColumns = [
    {
      key: 'serialNumber',
      label: <b>Sr.No.</b>,
      fixed: true,
      width: 60
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );
            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(`${ip}${rowData.attributes.CoverImage.data.attributes.url}`)}
              >
                <img
                  src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: 'Alias Code',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.AliasCode || 'Alias Code'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'Description',
      label: 'Description',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.Description || 'Description'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.Description" />
    },
    {
      key: 'ProductName',
      label: 'ProductName',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.ProductName || 'Product Name'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductName" />
    },
    {
      key: 'SizeUnit',
      label: 'Size Unit',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Dimensions</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Length, Width, Height, SizeUnit } = rowData.attributes;
            const sizeInfo = `${Length} x ${Width} x ${Height} ${SizeUnit}`;
            return sizeInfo;
          }}
        </Cell>
      )
    },

    {
      key: 'MOQ',
      label: 'MOQ',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.MOQ || 'MOQ'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.MOQ" />
    },
    {
      key: 'cbm',
      label: 'CBM',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.cbm || 'CBM'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.cbm" />
    },

    {
      key: 'FinishName',
      label: 'Finish',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.finish || 'Finish'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.FinishName" />
    },
    {
      key: 'ColorName',
      label: 'Color',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.color || 'Color'}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ColorName" />
    },
    {
      key: 'Remark',
      label: 'Remark',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Remark</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {(rowData, rowIndex) => {
            const queryAllDataItem = Array.isArray(queryAllData)
              ? queryAllData.find(item => item.productid == rowData.id)
              : null;

            return (
              <Input
                defaultValue={queryAllDataItem?.remark || ''}
                onChange={value => handleInputChange('Remark', value, rowIndex, rowData)}
              />
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'Price',
      label: 'Price',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{attributesName?.SalePrice || 'Price'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {(rowData, rowIndex) => {
            const data = Array.isArray(queryAllData)
              ? queryAllData.find(item => item.productid == rowData.id)
              : null;
            return (
              <Input
                defaultValue={data ? data.price : ''}
                type="number"
                onChange={value => handleInputChange('Price', value, rowIndex, rowData)}
              />
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'Query',
      label: 'Query',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Query</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {(rowData, rowIndex) => {
            const dataa = Array.isArray(queryAllData)
              ? queryAllData.find(item => item.productid == rowData.id)
              : null;
            return (
              <SelectPicker
                data={selectData}
                id="query"
                name="query"
                value={dataa?.query}
                onChange={value => handleInputChange('query', value, rowIndex, rowData)}
                block
                placeholder="Select Query"
              />
            );
          }}
        </Table.Cell>
      )
    },

    {
      key: 'Action',
      label: 'Action',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {rowData => (
            <IconButton
              size="sm"
              icon={<TrashIcon />}
              color="red"
              appearance="primary"
              active
              onClick={() => handleDeleteRow(rowData.id)}
            />
          )}
        </Table.Cell>
      )
    }
  ];
  const ip = globalIP;
  const location = useLocation();
  const C_A_id = location.state.C_A_id; //C_A_id (Client Activity id)
  const selectedItemsArray = location.state.selectedItems.split(',');
  const [activityAllData, setActivityAllData] = useState([]);
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns.map(column => column.key).filter(key => key !== 'ProductCost')
  );
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  const [data1234, setData1234] = useState<YourDataType[]>([]);
  const [loading, setLoading] = useState(true);
  // console.log('data1234');
  // console.log(data1234);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);

    const productvarid = selectedItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');
    const response = await fetch(
      `${ip}/api/products?${productvarid}&populate=*&pagination[page]=1`
    );
    const response1 = await fetch(
      `${ip}/api/variant-products?${productvarid}&populate=*&pagination[page]=1`
    );
    const json = await response.json();
    const json1 = await response1.json();
    const allSelectedItems = [];
    const allSelectedItems1 = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/products?${productvarid}&populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allSelectedItems.push(...pageJson.data);
    }
    for (let page = 1; page <= json1.meta.pagination.pageCount; page++) {
      const pageResponse1 = await fetch(
        `${ip}/api/variant-products?${productvarid}&populate=*&pagination[page]=${page}`
      );
      const pageJson1 = await pageResponse1.json();
      allSelectedItems1.push(...pageJson1.data);
    }
    const alldata = [...allSelectedItems, ...allSelectedItems1];
    setData1234(alldata);
    setLoading(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${ip}/api/clientactivities?populate=*&pagination[page]=1`);
      const json = await response.json();
      setActivityAllData(json.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const main_id = sessionStorage.getItem('main_id');
      const response = await fetch(`${globalIP}/api/clientactivities/${main_id}?populate=*`);
      const allSelectedItems = await response.json();
      setQueryAllData(allSelectedItems.data.attributes.sentquery);
    };

    fetchData();
  }, []);

  const dataWithSerialNumbers = data1234
    .slice()
    .reverse()
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));
    const handleDeleteRow = id => {
      setData1234(prevData => {
        const updatedData = prevData.filter(item => item.id !== id);
        if (updatedData.length === 0) {
          // Navigate to the desired page if no items remain
          navigate(`/${ugr}/client/product`);
        }
        return updatedData;
      });
    
      setEnquiry(prevEnquiry => {
        return {
          ...prevEnquiry,
          EnquiryProduct: prevEnquiry.EnquiryProduct.filter(item => item.productid != id)
        };
      });
    };

  const [enquridata, setEnquriData] = useState(0);
  useEffect(() => {
    fetchDataEnc();
  }, []);
  const fetchDataEnc = async () => {
    const response = await fetch(`${ip}/api/client-enquiries?populate=*`);
    const json = await response.json();
    setEnquriData(json.meta.pagination.total);
  };

  const generateEncCode = () => {
    if (activityAllData.length == 1) {
      if (activityAllData[0].attributes.Queryno == null) {
        const queryNo = Number(activityAllData[0].attributes.Queryno) || 0;
        const nextCode = queryNo + 1;
        return `ENQ-${nextCode.toString().padStart(3, '0')}`;
      } else {
        const nextCode = Number(activityAllData[0].attributes.Queryno) + 1;
        return `ENQ-${nextCode.toString().padStart(3, '0')}`;
      }
    } else if (activityAllData.length > 1) {
      const nextCode = Number(activityAllData[0].attributes.Queryno) + 1;
      return `ENQ-${nextCode.toString().padStart(3, '0')}`;
    }
  };
  let nextCategoryCode1 = generateEncCode();
  const handleInputChange = (inputName, event, index, rowData) => {
    let value;
    if (event && event.target) {
      value = event.target.value;
    } else {
      value = event;
    }
    if (inputName === 'Remark') {
      nextCategoryCode1 = generateEncCode();
      const nextCategoryCode = nextCategoryCode1;
      setEnquiry(prevEnquiry => {
        const updatedEnquiryProduct = [...prevEnquiry.EnquiryProduct];
        const existingItem = updatedEnquiryProduct[index];
        updatedEnquiryProduct[index] = {
          ...existingItem,
          remark: value,
          enqcd: nextCategoryCode,
          Prdcd: rowData.attributes.ProductCode,
          productid: rowData.id,
          typecode: rowData.attributes.CategoryCode
        };
        return {
          ...prevEnquiry,
          EnquiryProduct: updatedEnquiryProduct
        };
      });
    } else if (inputName == 'Price') {
      nextCategoryCode1 = generateEncCode();
      const nextCategoryCode = nextCategoryCode1;
      setEnquiry(prevEnquiry => {
        const updatedEnquiryProduct = [...prevEnquiry.EnquiryProduct];
        const existingItem = updatedEnquiryProduct[index];

        updatedEnquiryProduct[index] = {
          ...existingItem,
          BuyerPrice: value,
          enqcd: nextCategoryCode,
          Prdcd: rowData.attributes.ProductCode,
          productid: rowData.id,
          typecode: rowData.attributes.CategoryCode
        };
        return {
          ...prevEnquiry,
          EnquiryProduct: updatedEnquiryProduct
        };
      });
    } else if (inputName == 'query') {
      nextCategoryCode1 = generateEncCode();
      const nextCategoryCode = nextCategoryCode1;
      setEnquiry(prevEnquiry => {
        const updatedEnquiryProduct = [...prevEnquiry.EnquiryProduct];
        const existingItem = updatedEnquiryProduct[index];
        updatedEnquiryProduct[index] = {
          ...existingItem,
          query: value,
          enqcd: nextCategoryCode,
          Prdcd: rowData.attributes.ProductCode,
          productid: rowData.id,
          typecode: rowData.attributes.CategoryCode
        };
        return {
          ...prevEnquiry,
          EnquiryProduct: updatedEnquiryProduct
        };
      });
    } else {
      setEnquiry({ ...enquiry, [inputName]: value });
    }
  };
  const [isLoading, setIsloading] = useState(false);
  // console.log(enquiry);

  const handleOkClick = async e => {
    e.preventDefault();
    setIsloading(true);
    if (data1234.length == enquiry.EnquiryProduct.length) {
      const data = enquiry.EnquiryProduct.map(item => {
        return {
          typecode: item?.typecode || '',
          productid: String(item?.productid) || '',
          productcode: item?.Prdcd || '',
          remark: item?.remark || '',
          price: Number(item.BuyerPrice) || 0,
          query: item?.query || '',
          enqcd: item?.enqcd,
          Message: message
        };
      });
      const prevData = await axios.get(`${globalIP}/api/clientactivities/${C_A_id}?populate=*`);
      let updatedOpenedProductData = data;
      const generateQueryNo = () => {
        if (activityAllData.length == 1) {
          if (activityAllData[0].attributes.Queryno == null) {
            return 1;
          } else {
            return Number(activityAllData[0].attributes.Queryno) + 1;
          }
        } else if (activityAllData.length > 1) {
          return Number(activityAllData[0].attributes.Queryno) + 1;
        }
      };
      const queryNo = await axios.put(
        `${globalIP}/api/clientactivities/${activityAllData[0].id}?populate=*`,
        {
          data: {
            Queryno: String(generateQueryNo())
          }
        }
      );
      const io = await axios.put(`${globalIP}/api/clientactivities/${C_A_id}?populate=*`, {
        data: {
          sentquery: [...prevData.data.data.attributes.sentquery, ...updatedOpenedProductData],
          Queryno: String(generateQueryNo())
        }
      });
      if (io.statusText == 'OK') {
        const CatalogLinkStatus = async status => {
          const data = await axios.put(
            `${globalIP}/api/catalogues/${handleDecrypt(
              sessionStorage.getItem('Cat_id')
            )}?populate=*`,
            {
              data: { LinkStatus: status }
            }
          );
        };
        CatalogLinkStatus('Query Sent');
        if (sessionStorage.getItem('loginemail')) {
          sendEmail('', String(generateQueryNo()));
        }
        setOpen(true);
        setIsloading(false);
      }
    } else {
      notify('Fill all fields', '');
      setIsloading(false);
    }
  };
  const notify = (message, placement?, type?) => {
    toaster.push(
      <Message showIcon type={type || 'error'}>
        {message}
      </Message>,
      { placement: placement || 'topEnd' }
    );
  };
  const sendEmail = async (to, message) => {
    const endpoint = `${globalIP}/api/email`;
    const tem = `
    <p>Dear User,</p>
    <p>Thank you for choosing ERP Daddy.</p>
    <p>Your query is Sended</p>
    <p>Your Enquiry number is ${message} </p>
    <p>Thank you for your cooperation.</p>
    <p>Best regards,</p>
    <p>ERP Daddy Private limited</p>
  `;
    const data = {
      to: handleDecrypt(sessionStorage.getItem('loginemail')),
      subject: 'Query Request',
      html: tem
    };
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.error('Failed to send email');
        toaster.push(
          <Message showIcon type="error">
            Failed to send email
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  if (!data1234.length) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '80vh'
        }}
        color="cyan"
      >
        <Loader size="lg" />
      </div>
    );
  }
  return (
    <>
      <Grid fluid>
        <Row>
          <Col xs={24}>
            <div style={{ padding: '5px 20px', display: 'flex', justifyContent: 'space-between' }}>
              <div></div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <IconButton
                  icon={<MenuIcon />}
                  active={showTabs == 1}
                  onClick={() => setShowTabs(1)}
                  className={
                    showTabs == 1 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                  }
                  id="bb"
                />
                <IconButton
                  icon={<GridIcon />}
                  active={showTabs == 2}
                  onClick={() => setShowTabs(2)}
                  className={
                    showTabs === 2 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                  }
                  id="bb"
                />
              </div>
            </div>
          </Col>

          <Col
            lg={18}
            xs={24}
            style={{ borderRight: '1px solid lightGrey', borderTop: '1px solid lightGrey' }}
          >
            <div style={{ padding: '10px' }}>
              {showTabs == 2 && (
                <GridItem
                  data={data1234}
                  handleInputChange={handleInputChange}
                  handleOkClick={handleOkClick}
                  queryAllData={queryAllData}
                  handleDeleteRow={handleDeleteRow}
                  selectData={selectData}
                  isLoading={isLoading}
                  attributesName={attributesName}
                  setData1234={setData1234}
                />
              )}

              {showTabs == 1 && (
                <CustomTable
                  data1234={data1234}
                  dataWithSerialNumbers={dataWithSerialNumbers}
                  defaultColumns={defaultColumns}
                  columnKeys={columnKeys}
                  handleOkClick={handleOkClick}
                  CustomHeaderCell={CustomHeaderCell}
                  CustomCell={CustomCell}
                  loading={loading}
                  attributesName={attributesName}
                />
              )}
              {open && <SuccessModal open={open} setOpen={setOpen} navigate={navigate} />}
            </div>
          </Col>
          <Col lg={6} xs={24} className="query-message">
            <div style={{ padding: '10px 10px' }}>
              <h6>Your Message</h6>
              <Input
                as="textarea"
                rows={5}
                placeholder="Your Message"
                onChange={e => setMessage(e)}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    </>
  );
};

export default BuyerWeb;

const CustomTable = React.memo(
  ({
    data1234,
    dataWithSerialNumbers,
    defaultColumns,
    columnKeys,
    handleOkClick,
    CustomHeaderCell,
    CustomCell,
    loading,
    queryAllData,
    attributesName
  }) => {
    return (
      <div className="row" style={{ position: 'relative' }}>
        <b>{data1234.length} Products</b>
        <Table
          rowHeight={60}
          data={dataWithSerialNumbers || []}
          height={400}
          rowKey="id"
          loading={loading}
          bordered
          cellBordered
          wordWrap="break-word"
        >
          {defaultColumns.map(column => {
            if (columnKeys.includes(column.key)) {
              const { key, label, headerCell, cell, ...rest } = column;
              return (
                <Table.Column {...rest} key={key} align="center">
                  {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                  {cell || <CustomCell dataKey={key} />}
                </Table.Column>
              );
            }
            return null;
          })}
        </Table>
        <Stack
          justifyContent="flex-end"
          style={{ position: 'sticky', bottom: '20px', right: 0, background: 'white' }}
        >
          <Button style={{ background: '#005c80', color: 'white' }} onClick={handleOkClick}>
            Send Request
          </Button>
        </Stack>
      </div>
    );
  }
);

const GridItem = React.memo(
  ({
    data,
    handleInputChange,
    handleOkClick,
    queryAllData,
    handleDeleteRow,
    selectData = [],
    isLoading,
    attributesName,
    setData1234
  }) => {
    return (
      <div className="row">
        <Grid fluid>
          <Row>
            {data.map((item, rowIndex) => {
              const selectedData = Array.isArray(queryAllData)
                ? queryAllData.find(items => items.productid == item.id)
                : null;

              return (
                <Col lg={12} sm={24} key={item.id} style={{ marginBottom: '8px', cursor: 'move' }}>
                  <Panel bordered style={{ position: 'relative' }}>
                    <Row>
                      <Col xs={10}>
                        <div
                          style={{
                            width: '150px',
                            height: '150px',
                            margin: 'auto',
                            borderRadius: '5px',
                            overflow: 'hidden'
                          }}
                          className="activity-image"
                        >
                          <img
                            src={`${globalIP}${item.attributes.CoverImage.data.attributes.url}`}
                            alt=""
                            style={{ width: '100%', height: '100%' }}
                          />
                        </div>
                      </Col>
                      <Col xs={14}>
                        <div style={{ padding: '10px 20px 0 15px' }}>
                          <h6 style={{ fontSize: '12px' }}>{item.attributes.ProductName}</h6>
                          <span style={{ fontSize: '14px' }} className="roboto-regular">
                            {attributesName?.AliasCode || 'Alias Code'} :{' '}
                            {item.attributes.ProductId}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            padding: '10px 0px 10px 15px',
                            gap: '10px'
                          }}
                          className="mobile-grid-change"
                        >
                          <SelectPicker
                            data={selectData || []}
                            id="query"
                            size="sm"
                            name="query"
                            style={{ width: '100%' }}
                            defaultValue={item.query}
                            onChange={value => handleInputChange('query', value, rowIndex, item)}
                            block
                            placeholder="Select Query"
                          />
                          <InputNumber
                            style={{ width: '100%' }}
                            placeholder="Price"
                            size="sm"
                            onChange={value => handleInputChange('Price', value, rowIndex, item)}
                            defaultValue={item.price}
                          />
                        </div>
                        <div className="mobile-grid-hide">
                          <Input
                            as="textarea"
                            rows={4}
                            placeholder="Remark"
                            onChange={value => handleInputChange('Remark', value, rowIndex, item)}
                            defaultValue={item.remark}
                          />
                        </div>
                      </Col>
                      <Col xs={24} className="mobile-show-grid">
                        <div style={{ padding: '0px 0px 0px 0px' }}>
                          <Input
                            as="textarea"
                            rows={4}
                            placeholder="Remark"
                            onChange={value => handleInputChange('Remark', value, rowIndex, item)}
                            defaultValue={item.remark}
                          />
                        </div>
                      </Col>
                      <Col xs={24} className="mobile-show-grid">
                        <div style={{ padding: '10px 0px 0px 0px' }}>
                          <IconButton
                            icon={<TrashIcon />}
                            size="sm"
                            color="red"
                            appearance="primary"
                            onClick={() => handleDeleteRow(item.id)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <IconButton
                      icon={<TrashIcon />}
                      size="sm"
                      color="red"
                      appearance="primary"
                      style={{ position: 'absolute', bottom: '10px', left: '10px' }}
                      className="mobile-grid-hide"
                      onClick={() => handleDeleteRow(item.id)}
                    />
                  </Panel>
                </Col>
              );
            })}
          </Row>
        </Grid>
        <Stack
          justifyContent="flex-end"
          style={{ position: 'fixed', bottom: '20px', right: '20px' }}
        >
          <Button
            onClick={handleOkClick}
            loading={isLoading}
            disabled={isLoading}
            style={{ background: '#005c80', color: 'white' }}
          >
            Send Request
          </Button>
        </Stack>
      </div>
    );
  }
);

const SuccessModal = ({ open, setOpen, navigate }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Modal.Body>
        <Stack direction="column">
          <Icon
            as={CheckOutlineIcon}
            color="cyan"
            style={{ fontSize: '100px', marginBottom: '20px' }}
          />
          <b>Saved Successfully</b>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="primary"
          color="cyan"
          onClick={() => {
            setOpen(false);
            navigate(`/${ugr}/client/home-page`);
            // navigate(
            //   `/${ugr}/client/apptwo?Key=${sessionStorage.getItem(
            //     'Key'
            //   )}&id=${sessionStorage.getItem('idParam')}&Cat_id=${sessionStorage.getItem('Cat_id')}`
            // );
          }}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
